import React, { useEffect } from 'react'
import { createGlobalStyle, ThemeProvider } from 'styled-components'
import { Chat, ChatProps } from './chat'
import { requestNotificationPermission } from './utils'
import 'sanitize.css'
import { signalLoaded } from './messaging'

const GlobalStyles = createGlobalStyle`
  html {
    font-family: "Lato", "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -moz-font-feature-settings: "liga", "kern";
  }
  .icon {
    width: 16px;
    height: 16px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
  emoji-picker {
    width: 300px;
    height: 250px;
    --num-columns: 6;
    --category-emoji-size: 16px;
    --input-placeholder-color: #FFFFFF;
    --emoji-size: 20px;
  }
`

interface AppProps extends ChatProps {
}
function App({ companyInfo, visitor }: AppProps) {
  let colors: string[] = []
  try {
    colors.push(...JSON.parse(companyInfo.themeColor))
  } catch (e) {
    colors.push(companyInfo.themeColor)
  }
  const gradientColors = companyInfo.gradientColor ? companyInfo.gradientColor : colors
  const theme = {
      themeColor: colors[0] || '#000000',
      backgroundImage: `linear-gradient(to right, ${gradientColors[0]}, ${gradientColors[1] ?? gradientColors[0]})`,
      logo: companyInfo.squareLogo || 'https://img.bagevent.com/resource/20200527/1752440441234038.png'
  }
  useEffect(() => requestNotificationPermission(), [])
  useEffect(() => {
    setTimeout(() => signalLoaded(), 100)
  }, [])
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Chat visitor={visitor} companyInfo={companyInfo} />
    </ThemeProvider>
  )
}

export default App
